import { actionCreator } from 'utils';
import {
    START_PALETTE,
    LOAD_JOB_PALETTES_TO_START,
    LOAD_COATING_IN,
    SET_EMPTY_START_PALETTE,
} from '../types/coatingInTypes';

// L O A D   C O A T I N G   I N
export function loadCoatingIn() {
    return {
        type: LOAD_COATING_IN,
    };
}

export function loadCoatingInRes(data) {
    return {
        type: actionCreator(LOAD_COATING_IN, 'res'),
        data,
    };
}

export function loadCoatingInErr() {
    return {
        type: actionCreator(LOAD_COATING_IN, 'err'),
    };
}
// L O A D   C O A T I N G   I N

// S T A R T   P A L E T T E
export function startPalette(bulk, bulkDelete) {
    return {
        type: START_PALETTE,
        bulk,
        bulkDelete,
    };
}

export function startPaletteRes(success) {
    return {
        type: actionCreator(START_PALETTE, 'res'),
        success,
    };
}

export function startPaletteErr(error) {
    return {
        type: actionCreator(START_PALETTE, 'err'),
        error,
    };
}

export function setEmptyStartPalette() {
    return {
        type: SET_EMPTY_START_PALETTE,
    };
}
// S T A R T   P A L E T T E

// L O A D   J O B   P A L E T T E S   T O   S T A R T
export function loadJobPalettesToStart(paletteNumber) {
    return {
        type: LOAD_JOB_PALETTES_TO_START,
        paletteNumber,
    };
}

export function loadJobPalettesToStartRes(data) {
    return {
        type: actionCreator(LOAD_JOB_PALETTES_TO_START, 'res'),
        data,
    };
}

export function loadJobPalettesToStartErr() {
    return {
        type: actionCreator(LOAD_JOB_PALETTES_TO_START, 'err'),
    };
}
// L O A D   J O B   P A L E T T E S   T O   S T A R T
